import React from 'react';
import { useTranslation } from 'next-i18next';
import { TimelinePickupOpeningTimes } from '@interfaces/models/timeline';
import styles from '../popin.module.scss';
import { OkButtonView, PopinView } from './common';

const PickupOpeningTimesView: React.FC<{
  closePopin: () => void;
  openingTimes: TimelinePickupOpeningTimes;
}> = ({ closePopin, openingTimes }) => {
  const { t } = useTranslation(['orders-sales', 'common']);
  const { monday, tuesday, wednesday, thursday, friday, saturday, sunday } = openingTimes;
  const rows = [
    { label: t('common:DATETIME.MONDAY'), value: monday },
    { label: t('common:DATETIME.TUESDAY'), value: tuesday },
    { label: t('common:DATETIME.WEDNESDAY'), value: wednesday },
    { label: t('common:DATETIME.THURSDAY'), value: thursday },
    { label: t('common:DATETIME.FRIDAY'), value: friday },
    { label: t('common:DATETIME.SATURDAY'), value: saturday },
    { label: t('common:DATETIME.SUNDAY'), value: sunday },
  ];
  const closed = t('MY_ACCOUNT.ORDERS_SALES.DELIVERY.CLOSED');
  return (
    <PopinView
      closePopin={closePopin}
      title={t('MY_ACCOUNT.ORDERS_SALES.DELIVERY.OPENING_TIME')}
    >
      <div className={styles.ordersSales__popin__openingTime}>
        {rows.map(({ label, value }) => {
          return (
            <div
              key={label}
              className={styles.ordersSales__popin__openingTime__row}
            >
              <div className={styles.ordersSales__popin__openingTime__row__text}>{label}</div>
              <div className={styles.ordersSales__popin__openingTime__row__text}>{value || closed}</div>
            </div>
          );
        })}
      </div>
      <div className={styles.ordersSales__popin__buttons}>
        <OkButtonView
          isSubmitting={false}
          onClick={closePopin}
        >
          {t('MY_ACCOUNT.ORDERS_SALES.DELIVERY.GOT_IT')}
        </OkButtonView>
      </div>
    </PopinView>
  );
};

export default PickupOpeningTimesView;
